package com.shadowings.gero.domain.repository

interface AnalyticsRepository {
    fun logEvent(name: String, params: Map<String, Any> = emptyMap())
    fun setUserProperty(name: String, value: String) {}
    fun logStartLesson(lessonId: String)
    fun logStartQuiz(lessonId: String)
    fun logWordViewed(wordId: String, meaning: String)
    fun logHieroViewed(hieroId: String, unicode: String)
    fun logQuizCompleted(lessonId: String, score: Int, total: Int, errors: Int)
    fun logStatClicked(statType: String)
    fun logFavoriteToggled(wordId: String, isFavorite: Boolean)
    fun logCharacterCustomized(character: String, category: String, colorIndex: Int)
    fun logCharacterReset(character: String)
    fun logSignOut()
    fun logTestModeToggled(enabled: Boolean)
    fun logDataReset()
    fun logTutorialStarted()
    fun logTutorialCompleted()
    fun logSignUp()
    fun logLogin()
    fun logSecurityThreat(threatType: String, details: String = "") {}
    fun logFeaturePollResponse(option: String, freeText: String = "") {}
    fun logClickCompendio() {}
    fun logClickBuilder() {}
    fun logClickPersonaggi() {}
    fun logClickProfilo() {}
    fun logClickCorreggi() {}
    fun logTabSimboli() {}
    fun logTabParole() {}
    fun logTabRegole() {}
    fun logTabImmagini() {}
    fun logTabAlyn() {}
    fun logTabNilo() {}
    fun logTabZeta() {}
    fun logTabMasko() {}
}
